import {
  consumePlayerService,
  featureToggleService, language,
  leaveGameService,
  saveRedirectUrlForLeaveGame,
  setApiAuthToken,
  usePlayerStore,
} from '@slot-nx/core'
import { gameConfig } from '../../config'
import { gameInfoService } from '../gameInfo'
import { MachineActionType, sweetBombMachine } from '../../../machine/sweetbombMachine'
import { AddBuyBonusBundle } from './loadBuyBonusPopup'
export async function inGame() {
  const urlParams = new URLSearchParams(window.location.search)
  saveRedirectUrlForLeaveGame(urlParams)

  const authToken = await consumePlayerService.consumePlayer(urlParams.get('token'))
  setApiAuthToken(authToken)
  usePlayerStore.setState({
    authToken,
  })

  // if (import.meta.env.MODE !== 'development') await initSignalrConnection(authToken, gameConfig.name);
  leaveGameService.registerLeaveGameEvent()
  await Promise.all([featureToggleService.getFeatureToggle(), gameInfoService.getGameInfo(), AddBuyBonusBundle(language)])

  window.history.replaceState({ path: '' }, '', `/${gameConfig.name}/index.html`)

  sweetBombMachine.send({ type: MachineActionType.gameReady })
}
